import { Suspense, lazy } from 'react';
import Domain from '../components/Domain';
import LoadingSpinner from '../components/LoadingSpinner';
import Nav from '../components/Nav';
import ProtectedRoute from '../components/ProtectedRoute';
import PublicRoute from '../components/PublicRoute';

const Loadable = (Component: any) => (props: any) => (
  <Suspense fallback={<LoadingSpinner />}>
    <Component {...props} />
  </Suspense>
)

const Statistics = Loadable(lazy(() => import('../components/Statistics')));
const LoginPage = Loadable(lazy(() => import('../components/Login')));

const routes: any[] = [
  { 
    path: '/login', 
    element: (
      <PublicRoute>
        <LoginPage />
      </PublicRoute>
    )
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <Nav />
      </ProtectedRoute>
    ),
    children: [
      { path: '/', element: <Statistics /> },
      { path: '/domain', element: <Domain /> },
    ],
  },
];

export default routes;
